<!--
* UIID: UI-DLB-MBL-100
* UI Name:  Mapper List
* Modify Date: 2020/07/15
-->
<template>
  <div>
    <v-row no-gutters class="scanner-section">
      <!-- Scanner Data -->
      <v-col cols="12" lg="6" md="6" class="pl-0 pb-0 pt-0 pr-12px">
        <v-row no-gutters>
          <v-col cols="12" class="scanner-grid-pd zoom-mapper-file">
            <v-row class="v-grid-title row-pd mb-4">
              <v-col class="date-query-section pa-0 mt-0" cols="12" lg="3" md="3">
                <div class="pl-0 pt-0 pb-0 d-inline-flex">
                  <span class="scanner-label">{{ $t('lbl.mapBuilder.mapperTitle') }}</span>
                </div>
              </v-col>
              <v-col class="date-query-section pa-0 mt-0 text-right" cols="12" lg="9" md="9">
                <!-- 2022.01.13 213960 SPKA-365 Group 2 buttons to v-menu  -->
                <div class="btn-form-control mb-0">
                  <v-menu open-on-hover offset-y>
                    <template v-slot:activator="{ on, attrs, value }">
                      <v-btn class="btn-active btn-browser btn-inline" v-bind="attrs" v-on="on">
                        Load
                        <v-icon :class="value ? 'fa-rotate-180' : ''">
                          mdi mdi-chevron-down
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list class="map-builder-custom-list">
                      <v-list-item
                        v-for="(item, index) in loadTypes"
                        :key="index"
                        @click="changeLoadType(item)"
                      >
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <!-- <v-btn
                    @click="loadMapperLocal"
                    class="btn-active btn-browser btn-inline"
                  >
                    <v-icon x-small class="mr-1 show-load-icon">fas fa-file-upload</v-icon>
                    <span class="show-load-txt">{{$t('btn.mapBuilder.loadFromLocal')}}</span>
                  </v-btn> -->
                  <input
                    @change="inputMapperFileLocal"
                    id="mapper_data"
                    type="file"
                    ref="mapper_data"
                    style="display: none"
                    accept=".cpp"
                  />
                  <!-- <v-btn
                    @click="openLoadFilePop({mode : 'Load', filetype: 'mapper'})"
                    class="btn-active btn-browser btn-inline"
                  >
                    <v-icon x-small class="mr-1 show-load-icon">fas fa-cloud-download-alt</v-icon>
                    <span class="show-load-txt">{{$t('btn.mapBuilder.loadFromServer')}}</span>
                  </v-btn> -->
                  <v-btn @click="openMapperListDialog" class="btn-active btn-scanner btn-inline">
                    <v-icon x-small class="mr-1 show-load-icon">fa fa-list</v-icon>
                    <span class="show-load-txt">{{ $t('btn.mapBuilder.mapperList') }}</span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters class="scanner-icon">
              <v-col class="pa-0 d-inline-flex" cols="12" lg="7" md="6">
                <div class="mapper-file-name" v-if="this.mapperFileName != ''">
                  {{ this.mapperFileName }}
                </div>
                <div class="mapper-file-name map-version mx-2" v-if="version">
                  {{ `v ${version}` }}
                </div>
                <div v-if="this.checkInYN === 'N'" class="mapper-status status-checked-in">
                  {{ $t('btn.mapBuilder.checkedIn') }}
                </div>
                <div v-if="this.checkInYN === 'Y'" class="mapper-status status-checked-out">
                  {{ $t('btn.mapBuilder.checkedOut') }}
                </div>
              </v-col>
              <v-col class="pa-0 text-right" cols="12" lg="5" md="6">
                <a class="select-code-table" @click="openCodeTableDialog">{{ codeTableName }}</a>
                <v-menu
                  offset-x
                  :close-on-content-click="false"
                  transition="scale-transition"
                  origin="left"
                >
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      x-small
                      text
                      icon
                      class="mr-1 ml-1"
                      v-bind="attrs"
                      v-on="on"
                      style="margin-bottom: 2px"
                    >
                      <icon-svg iconName="clear" />
                    </v-btn>
                  </template>
                  <v-list dense class="text-xs custom-menu">
                    <v-list-item @click="clearView('mapper')">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('btn.mapBuilder.clear') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="clearTab()">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('btn.mapBuilder.clearAll') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-btn class="btn-expand" x-small text icon @click="expandView('mapper')">
                  <icon-svg iconName="expand" />
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters class="text-view-scanner">
              <div class="CodeMirror">
                <MapperViewer
                  v-model="mapperFileContent"
                  :options="this.cmOption"
                  @changes="onChangeTextView('mapper')"
                  ref="mapperFile"
                ></MapperViewer>
              </div>
            </v-row>
            <v-row class="btn-form-control">
              <v-spacer></v-spacer>
              <v-col class="data-query-section pb-0 pt-0 mt-0 text-right" cols="12" lg="12" md="12">
                <div class="pl-0 pt-0 pb-0 d-inline-flex">
                  <v-autocomplete
                    v-if="isDlb"
                    v-model="libraryVersion"
                    @change="onVersionChange(libraryVersion)"
                    :menu-props="{ offsetY: true }"
                    :items="libraryItem"
                    placeholder="Library"
                    class="custom-selectbox"
                    hide-details
                    dense
                    solo
                  ></v-autocomplete>
                </div>
                <div class="pl-0 pt-0 pb-0 d-inline-flex mr-0">
                  <v-btn
                    @click="buildMapper"
                    :disabled="isValidCompileMapper"
                    class="btn-active btn-search mt-0 mb-0"
                  >
                    <!-- <v-icon small class="mr-2">fa fa-cubes</v-icon> -->
                    {{ $t('btn.mapBuilder.compile') }}
                  </v-btn>
                  <v-btn
                    @click="executeMapper"
                    :disabled="isValidExecuteMapper"
                    class="btn-active btn-execute"
                  >
                    <!-- <icon-svg iconName="execution"/> -->
                    {{ $t('btn.mapBuilder.execute') }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters class="scanner-icon">
              <v-col class="pa-0" cols="12" lg="10" md="10">
                <div class="file-name">{{ $t('lbl.mapBuilder.resultTitle') }}</div>
              </v-col>
              <v-col class="pa-0 text-right btn-expand" cols="12" lg="2" md="2">
                <v-btn x-small text icon @click="expandView('resultBuild')">
                  <icon-svg iconName="expand" />
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters class="build-result-view">
              <div class="CodeMirror">
                <resultBuildViewer
                  :value="this.resultField"
                  :options="this.buildCmOption"
                  ref="resultBuild"
                ></resultBuildViewer>
              </div>
            </v-row>
            <v-row class="btn-grid no-gutters btn-form-control">
              <v-col cols="12" lg="6" md="6" class="pa-0 pr-3 text-left">
                <v-btn
                  @click="saveMapperFile"
                  :disabled="isValidMapper"
                  class="btn-active btn-search"
                  >{{ $t('btn.common.save') }}</v-btn
                >
                <v-btn
                  @click="openLoadFilePop({ mode: 'Save', filetype: 'mapper' })"
                  :disabled="isValidMapper"
                  class="btn-active btn-search"
                  >{{ $t('btn.mapBuilder.saveAs') }}</v-btn
                >
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" lg="6" md="6" class="pa-0 text-right">
                <v-btn
                  :disabled="checkInYN !== 'N'"
                  @click="openCheckOut"
                  class="btn-active btn-search"
                  >{{ $t('btn.mapBuilder.checkOut') }}</v-btn
                >
                <v-btn
                  :disabled="isDisableChkMap || checkInYN !== 'Y'"
                  @click="openMapperCheckInDialog"
                  class="btn-active btn-search"
                  >{{ $t('btn.mapBuilder.checkIn') }}</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="6" md="6">
        <v-row no-gutters>
          <!-- Scanner Input Data -->
          <v-col cols="12" xl="6" lg="6" md="6" class="pa-0">
            <v-row no-gutters>
              <v-col cols="12" class="scanner-grid-pd zoom-m-biz-data">
                <v-row class="v-grid-title row-pd mb-4">
                  <v-col class="date-query-section pa-0 mt-0" cols="12" lg="3" md="4">
                    <span class="scanner-label">{{
                      $t('lbl.mapBuilder.mapperInputFileTitle')
                    }}</span>
                  </v-col>
                  <v-col class="date-query-section pa-0 mt-0 text-right" cols="12" lg="9" md="8">
                    <!-- 2022.01.13 213960 SPKA-365 Group 2 buttons to v-menu  -->
                    <div class="btn-form-control mb-0">
                      <v-menu open-on-hover offset-y>
                        <template v-slot:activator="{ on, attrs, value }">
                          <v-btn
                            class="btn-active btn-browser btn-inline mr-0"
                            v-bind="attrs"
                            v-on="on"
                          >
                            Load
                            <v-icon :class="value ? 'fa-rotate-180' : ''">
                              mdi mdi-chevron-down
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list class="map-builder-custom-list">
                          <v-list-item
                            v-for="(item, index) in loadTypes"
                            :key="index"
                            @click="changeLoadInputType(item)"
                          >
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <!-- <v-btn
                        @click="loadInputLocal"
                        class="btn-active btn-browser btn-inline"
                      >
                        <v-icon x-small class="mr-1 show-load-icon">fas fa-file-upload</v-icon>
                        <span class="show-load-txt">{{$t('btn.mapBuilder.loadFromLocal')}}</span>
                      </v-btn> -->
                      <input
                        @change="inputDataFileLocal"
                        id="input_data"
                        type="file"
                        ref="input_data"
                        style="display: none"
                        accept=".txt, .biz, .json, .xml"
                      />
                      <!-- <v-btn
                        @click="openLoadFilePop({mode: 'Load', filetype: 'inputMap'})"
                        class="btn-active btn-browser btn-inline"
                      >
                        <v-icon x-small class="mr-1 show-load-icon">fas fa-cloud-download-alt</v-icon>
                        <span class="show-load-txt">{{$t('btn.mapBuilder.loadFromServer')}}</span>
                      </v-btn> -->
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters class="scanner-icon">
                  <v-col class="pa-0" cols="12" lg="10" md="10">
                    <div class="file-name" v-if="this.inputFileName != ''">
                      {{ this.inputFileName }}
                    </div>
                  </v-col>
                  <v-col class="pa-0 text-right btn-expand" cols="12" lg="2" md="2">
                    <v-btn x-small text icon @click="clearView('biz')" class="mr-1">
                      <icon-svg iconName="clear" />
                    </v-btn>
                    <v-btn x-small text icon @click="expandView('biz')">
                      <icon-svg iconName="expand" />
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row no-gutters class="text-view-input">
                  <div class="CodeMirror">
                    <BIZViewer
                      v-model="inputFileContent"
                      :options="this.cmOption"
                      @changes="onChangeTextView('biz')"
                      ref="bizFile"
                    ></BIZViewer>
                  </div>
                </v-row>
                <v-row class="btn-grid no-gutters btn-form-control">
                  <v-btn
                    @click="saveInputFile"
                    :disabled="isValidSave"
                    class="btn-active btn-search"
                    >{{ $t('btn.common.save') }}</v-btn
                  >
                  <v-btn
                    @click="openLoadFilePop({ mode: 'Save', filetype: 'inputMap' })"
                    :disabled="isValidSave"
                    class="btn-active btn-search"
                    >{{ $t('btn.mapBuilder.saveAs') }}</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <!-- //BizData -->
          <v-col cols="12" xl="6" lg="6" md="6" class="pt-0 pb-0 pl-12px pr-0">
            <v-row no-gutters>
              <v-col cols="12" class="scanner-grid-pd zoom-output-file">
                <v-row class="v-grid-title row-pd mb-4">
                  <span class="scanner-label">{{
                    $t('lbl.mapBuilder.mapperOutputFileTitle')
                  }}</span>
                </v-row>
                <v-row no-gutters class="scanner-icon">
                  <v-col class="pa-0" cols="12" lg="10" md="10">
                    <div class="file-name" v-if="this.outputFileName != ''">
                      {{ this.outputFileName }}
                    </div>
                  </v-col>
                  <v-col class="pa-0 text-right btn-expand" cols="12" lg="2" md="2">
                    <v-btn x-small text icon @click="clearView('output')" class="mr-1">
                      <icon-svg iconName="clear" />
                    </v-btn>
                    <v-btn x-small text icon @click="expandView('output')">
                      <icon-svg iconName="expand" />
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row no-gutters class="text-view-biz">
                  <div class="CodeMirror">
                    <OutputDataViewer
                      v-model="outputFileContent"
                      :options="this.cmOption"
                      ref="outputFile"
                    ></OutputDataViewer>
                  </div>
                </v-row>
                <v-row class="btn-grid no-gutters btn-form-control">
                  <v-btn
                    :disabled="isValidOutput"
                    @click="saveOutputFile"
                    class="btn-active btn-search"
                    >{{ $t('btn.common.save') }}</v-btn
                  >
                  <v-btn
                    @click="openLoadFilePop({ mode: 'Save', filetype: 'output' })"
                    :disabled="isValidOutput"
                    class="btn-active btn-search"
                    >{{ $t('btn.mapBuilder.saveAs') }}</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialogWindow
      ref="validateDialog"
      size="max"
      title="Warning"
      color="validation"
      :detail="validateMessage"
    ></dialogWindow>
    <!-- 2020/11/06 203737 Remove unused source
    <dialogWindow
      ref="successDialog"
      size="max"
      color="success"
      :detail="$t('msg.common.saveSuccess', ['File'])"
    ></dialogWindow> -->
    <dialogWindow
      ref="compileWarningDialog"
      size="max"
      title="Warning"
      color="validation"
      :detail="$t('msg.mapBuilder.compileWarning')"
    ></dialogWindow>
    <dialogWindow
      ref="checkOutDialog"
      size="max"
      :detail="$t('msg.mapBuilder.confirmCheckOut')"
      color="confirmation"
      show-cancel="true"
      @select-ok="onClickOkay"
    ></dialogWindow>
  </div>
</template>
<script>
import BIZViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import OutputDataViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import MapperViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import resultBuildViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { mapState } from 'vuex';
import $ from 'jquery';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import 'codemirror/mode/swift/swift.js';

// theme css
import 'codemirror/theme/rubyblue.css';

// active-line.js
import 'codemirror/addon/selection/active-line.js';

// styleSelectedText
import 'codemirror/addon/selection/mark-selection.js';
import 'codemirror/addon/search/searchcursor.js';

// highlightSelectionMatches
import 'codemirror/addon/scroll/annotatescrollbar.js';
import 'codemirror/addon/search/matchesonscrollbar.js';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/match-highlighter.js';

// keyMap
import 'codemirror/mode/clike/clike.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/comment/comment.js';
import 'codemirror/addon/dialog/dialog.js';
import 'codemirror/addon/dialog/dialog.css';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/search.js';
import 'codemirror/keymap/sublime.js';

// foldGutter
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/comment-fold.js';
import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/indent-fold.js';
import 'codemirror/addon/fold/markdown-fold.js';
import 'codemirror/addon/fold/xml-fold.js';
import cfg from '@/vue-caas/config/config.js';

// 2021.12.06 SPKA-304 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    OutputDataViewer,
    BIZViewer,
    MapperViewer,
    resultBuildViewer,
    dialogWindow,
    IconSvg,
  },
  props: {
    versionList: Object,
  },
  computed: {
    ...mapState('mapbuilder', {
      /* 2020/11/06 203737 Remove unused source
      foldList: "foldList",
      fileList: "fileList",*/
      savedFile: 'savedFile',
      buildResult: 'buildResult',
      exeResult: 'exeResult',
      libList: 'libList',
    }),
    ...mapState('common', {
      fileContent: 'fileContent',
    }),
    cmOption() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          readOnly: false,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        readOnly: false,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      };
    },
    buildCmOption() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          styleActiveLine: true,
          lineNumbers: false,
          line: false,
          readOnly: true,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        styleActiveLine: true,
        lineNumbers: false,
        line: false,
        readOnly: true,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      };
    },
    isValidSave() {
      if (this.inputFileContent.toString().trim() != '') {
        return false;
      }
      return true;
    },
    isValidMapper() {
      if (this.mapperFileContent.toString().trim() != '') {
        return false;
      }
      return true;
    },
    isValidOutput() {
      if (this.outputFileContent.toString().trim() != '') {
        return false;
      }
      return true;
    },
    isValidCompileMapper() {
      if (this.mapperFileName != '') {
        return false;
      }
      return true;
    },
    isValidExecuteMapper() {
      if (this.buildResultMSG == 'SUCCESS') {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      lastFoldIdBiz: '',
      lastFoldIdMapper: '',
      selectCodeId: '',
      isDisableChkMap: true,
      accessCheckIn: false,
      tab: null,
      inputFileContent: '',
      inputFileName: '',
      inputFile: '',
      inputFileSize: 0,
      fileID: '',
      inputFolderId: '',
      inputFileExtension: '',
      inputFileNameSave: '',
      mapperFileContent: '',
      mapperFileName: '',
      mapperFile: '',
      mapperFileID: '',
      mapperFileSize: 0,
      mapperFolderId: '',
      mapperFileExtension: '',
      mapperFileNameSave: '',
      outputFileContent: '',
      outputFileName: '',
      outputFile: '',
      outputFileID: '',
      outputFileSize: 0,
      outputFolderId: '',
      ouputFileExtension: '',
      outputFileNameSave: '',
      resultField: '',
      buildResultMSG: '',
      /* 2020/11/06 203737 Remove unused source
    arrLayoutDialog: [],
    dialogs: [],
    dialogId: 1,*/
      isSaved: false,
      validateMessage: '',
      codeTableName: '',
      codeListId: '',
      /* 2020/11/06 203737 Remove unused source
    items: [
      { tab: 'repository', content: 'Repository' },
      { tab: 'srm_list', content: 'SRM List' },
    ],
    queryFolderList: {
      header: [ 'USER_ID'],
      data: [{
        USER_ID:'',
      }],
    },
    queryFileList: {
      header: [ 'USER_ID','FOLD_ID'],
      data: [{
        USER_ID:'',
        FOLD_ID:'',
      }],
    },
    viewFileHeader: {
      header: [ 'FILE_ID'],
      data: [{
        FILE_ID:'',
      }],
    },*/
      saveItemsParams: {
        header: [
          'SYSSTATUS',
          'USER_ID',
          'FOLD_ID',
          'FILE_ID',
          'USR_FILE_NAME',
          'USR_FILE_SIZE',
          'USR_FILE_TYPE',
          'USR_FILE_KIND',
        ],
        data: [],
      },
      buildItemsParams: {
        header: ['FILE_ID', 'MAP_TYPE', 'LIB_VER', 'ORA_VER'],
        data: [],
      },
      exeItemsParams: {
        header: ['IN_FILE_ID', 'EX_FILE_ID', 'MAP_TYPE', 'LIB_VER', 'ORA_VER', 'CODE_CTG_ID'],
        data: [],
      },
      librarySearchItem: {
        header: ['CUST_ID'],
        data: [
          {
            CUST_ID: '',
          },
        ],
      },
      libraryItem: [],
      libraryVersion: '',
      oracleVersion: '',
      isDlb: false,
      loadTypes: [
        { text: 'Load From Local', value: 'local' },
        { text: 'Load From Server', value: 'server' },
      ],
      checkInYN: '',
      currenVersionData: null,
      version: '',
    };
  },

  created() {
    EventBus.$on('updateMapperStatus', this.updateMapperStatus);
    this.getLibraryVersion();
    this.codeTableName = this.$t('btn.mapBuilder.selectCodeTable');
    this.isDlb = cfg.isDlb;
    this.clearMovedData();
  },
  mounted() {},
  watch: {
    checkInYN() {
      if (this.checkInYN === '') {
        this.$emit('changeMapperVersionHistoryItem', null);
      }
    },
    versionList() {
      this.currenVersionData = this.versionList;
    },
  },

  methods: {
    clearTab() {
      this.clearView('output');
      this.clearView('mapper');
      this.clearView('biz');
    },
    clearMovedData() {
      var flag = 'N';
      Store.dispatch('mapbuilder/clearMovedData', flag);
    },
    onVersionChange(libver) {
      for (let i = 0; i < this.libList.length; i++) {
        if (libver === this.libList[i].SITE_CODE) {
          this.oracleVersion = this.libList[i].ORA_VER;
          break;
        }
      }
      console.log(this.oracleVersion);
    },
    getLibraryVersion() {
      this.librarySearchItem.data[0].CUST_ID = $cookies.get('comp-id');
      Store.dispatch('mapbuilder/queryLibraryList', this.librarySearchItem).then(() => {
        for (let i = 0; i < this.libList.length; i++) {
          if (this.isDlb) {
            let item = this.libList[i];
            this.libraryItem.push({
              text: item.SITE_NAME,
              value: item.SITE_CODE,
            });
          } else {
            if (this.libList[i].SITE_CODE === 'for_platform') {
              let item = this.libList[i];
              this.libraryItem.push({
                text: item.SITE_NAME,
                value: item.SITE_CODE,
              });
            }
          }
        }
        this.libraryVersion = this.libraryItem[0].value;
        this.onVersionChange(this.libraryVersion);
      });
    },
    saveInputFile(mode) {
      console.log('-------SaveNewInFile--------');
      //File Name blank
      if (this.inputFileName === '') {
        this.openLoadFilePop({ mode: 'Save', filetype: 'inputMap' });
        return;
      }
      // File Name  not blank
      else {
        if (this.inputFileContent.toString().trim() == '') {
          this.validateMessage = this.$t('msg.common.require', ['Biz Data Content']);
          this.$refs.validateDialog.dialog = true;
          return;
        } else {
          let savefile = {};
          savefile.SYSSTATUS = 'U';
          savefile.USER_ID = $cookies.get('user-id');
          savefile.FOLD_ID = this.inputFolderId;
          savefile.FILE_ID = this.fileID;
          savefile.USR_FILE_NAME = this.inputFileName;
          //203665 2020/11/13 fix common issue 17
          // savefile.USR_FILE_SIZE = this.inputFileSize
          savefile.USR_FILE_SIZE = new Blob([this.inputFileContent]).size;
          savefile.USR_FILE_TYPE = this.inputFileExtension;
          savefile.file = this.inputFileContent;
          savefile.USR_FILE_KIND = 'BIZ';
          this.saveItemsParams.data[0] = savefile;
          console.log('this is update----------->');
          Store.dispatch('mapbuilder/saveWorkSpaceMapFile', this.saveItemsParams).then(() => {
            this.fileID = this.savedFile[0].FILE_NAME;
          });
        }
      }
    },
    saveMapperFile() {
      // File Name  Blank
      if (this.mapperFileName === '') {
        this.openLoadFilePop({ mode: 'Save', filetype: 'mapper' });
        return;
      }
      // File Name not blank
      else {
        if (this.mapperFileContent.toString().trim() == '') {
          this.validateMessage = this.$t('msg.common.require', ['Mapper Content']);
          this.$refs.validateDialog.dialog = true;
          return;
        } else {
          let savefile = {};
          savefile.SYSSTATUS = 'U';
          savefile.USER_ID = $cookies.get('user-id');
          savefile.FOLD_ID = this.mapperFolderId;
          savefile.FILE_ID = this.mapperFileID;
          savefile.USR_FILE_NAME = this.mapperFileName;
          //203665 2020/11/13 fix common issue 17
          // savefile.USR_FILE_SIZE = this.mapperFileSize
          savefile.USR_FILE_SIZE = new Blob([this.mapperFileContent]).size;
          savefile.USR_FILE_TYPE = this.mapperFileExtension;
          savefile.file = this.mapperFileContent;
          savefile.USR_FILE_KIND = 'MAP';
          this.saveItemsParams.data[0] = savefile;
          console.log('this is update----------->');
          Store.dispatch('mapbuilder/saveWorkSpaceMapFile', this.saveItemsParams).then(() => {
            this.mapperFileID = this.savedFile[0].FILE_NAME;
            this.isSaved = true;
          });
        }
      }
    },
    saveOutputFile() {
      // File Name blank
      if (this.outputFileName === '') {
        this.openLoadFilePop({ mode: 'Save', filetype: 'output' });
        return;
      }
      // File Name not blank
      else {
        if (this.outputFileContent.toString().trim() == '') {
          this.validateMessage = this.$t('msg.common.require', ['Output Data Content']);
          this.$refs.validateDialog.dialog = true;
          return;
        } else {
          let savefile = {};
          savefile.SYSSTATUS = 'U';
          savefile.USER_ID = $cookies.get('user-id');
          savefile.FOLD_ID = this.outputFolderId;
          savefile.FILE_ID = this.outputFileID;
          savefile.USR_FILE_NAME = this.outputFileName;
          //203665 2020/11/13 fix common issue 17
          // savefile.USR_FILE_SIZE = this.outputFileSize;
          savefile.USR_FILE_SIZE = new Blob([this.outputFileContent]).size;
          savefile.USR_FILE_TYPE = this.ouputFileExtension;
          savefile.file = this.outputFileContent;
          savefile.USR_FILE_KIND = 'OUT';
          this.saveItemsParams.data[0] = outputFile;
          console.log('this is update----------->');
          Store.dispatch('mapbuilder/saveWorkSpaceMapFile', this.saveItemsParams).then(() => {
            this.outputFileID = this.savedFile[0].FILE_NAME;
          });
        }
      }
    },
    buildMapper() {
      if (this.mapperFileContent.toString().trim() == '') {
        this.validateMessage = this.$t('msg.common.require', ['Mapper Content']);
        this.$refs.validateDialog.dialog = true;
        return;
      } else {
        let savefile = {};
        savefile.SYSSTATUS = 'U';
        savefile.USER_ID = $cookies.get('user-id');
        savefile.FOLD_ID = this.mapperFolderId;
        savefile.FILE_ID = this.mapperFileID;
        savefile.USR_FILE_NAME = this.mapperFileName;
        //203665 2020/11/13 fix common issue 17
        // savefile.USR_FILE_SIZE = this.mapperFileSize
        savefile.USR_FILE_SIZE = new Blob([this.mapperFileContent]).size;
        savefile.USR_FILE_TYPE = this.mapperFileExtension;
        savefile.file = this.mapperFileContent;
        savefile.USR_FILE_KIND = 'MAP';
        this.saveItemsParams.data[0] = savefile;
        console.log('this is update----------->');
        Store.dispatch('mapbuilder/saveWorkSpaceMapFile', this.saveItemsParams).then(() => {
          this.mapperFileID = this.savedFile[0].FILE_NAME;
          this.isSaved = true;

          this.buildItemsParams.data[0] = {
            FILE_ID: this.mapperFileID,
            MAP_TYPE: 'MAPP',
            LIB_VER: this.libraryVersion,
            ORA_VER: this.oracleVersion,
          };
          Store.dispatch('mapbuilder/mapBuild', this.buildItemsParams).then(() => {
            console.log('--------- Finished to process Build ----------');
            this.buildResultMSG = this.buildResult[0].RESULT;
            this.resultField = this.buildResult[0].RESULT + '\r\n' + this.buildResult[0].MSG;
          });
        });
      }
    },
    executeMapper() {
      //203665 2020-10-09 CLV Clear output when execute [issue 22 MapBuilder]
      console.log('-------Execute--------');
      this.outputFileContent = '';
      this.outputFileName = '';
      this.outputFile = '';
      this.outputFileID = '';
      this.outputFileSize = 0;
      this.outputFolderId = '';
      this.ouputFileExtension = '';
      this.outputFileNameSave = '';
      if (this.mapperFileID == '' || this.fileID == '') {
        this.validateMessage = this.$t('msg.mapBuilder.executeWarning');
        this.$refs.validateDialog.dialog = true;
        return;
      }
      this.exeItemsParams.data[0] = {
        IN_FILE_ID: this.fileID,
        EX_FILE_ID: this.mapperFileID,
        MAP_TYPE: 'MAPP',
        LIB_VER: this.libraryVersion,
        ORA_VER: this.oracleVersion,
        CODE_CTG_ID: this.selectCodeId, // TBD - by April. Please change here for CodeTable
      };
      Store.dispatch('mapbuilder/mapExecute', this.exeItemsParams).then(() => {
        console.log('--------- Finished to process Execute ----------');
        if (this.exeResult[0].RESULT == 'FAIL') {
          this.resultField = this.exeResult[0].RESULT + '\r\n' + this.exeResult[0].MSG;
          this.isDisableChkMap = true;
          this.accessCheckIn = false;
        } else {
          this.resultField = this.exeResult[0].RESULT;
          this.outputFileContent = this.exeResult[0].MSG;
          this.isDisableChkMap = false;
          this.accessCheckIn = true;
        }
      });
    },
    loadInputLocal() {
      this.$refs.input_data.click();
    },
    inputDataFileLocal(e) {
      this.inputFileName = '';
      this.fileID = '';
      this.inputFileNameSave = e.target.files[0].name;
      this.inputFileExtension = e.target.files[0].name.split('.').pop();
      this.inputFile = e.target.files[0];
      this.isDisableChkMap = true;
      this.checkInYN = '';
      console.log(this.inputFile);
      var reader = new FileReader();
      reader.onload = (e) => {
        this.inputFileContent = reader.result;
      };
      reader.readAsText(e.target.files[0]);
    },
    loadMapperLocal() {
      this.$refs.mapper_data.click();
    },
    inputMapperFileLocal(e) {
      this.mapperFileName = '';
      this.mapperFileID = '';
      this.mapperFileNameSave = e.target.files[0].name;
      this.mapperFileExtension = e.target.files[0].name.split('.').pop();
      this.mapperFileSize = e.target.files[0].size;
      this.mapperFile = e.target.files[0];
      this.buildResultMSG = '';
      this.mapperFileID = '';
      this.resultField = '';
      this.isSaved = false;
      var reader = new FileReader();
      reader.onload = (e) => {
        this.mapperFileContent = reader.result;
        this.codeTableName = this.$t('btn.mapBuilder.selectCodeTable');
      };
      reader.readAsText(e.target.files[0]);
    },
    openLoadFilePop(data) {
      let { mode, filetype } = data;
      if (mode == 'Load') {
        let callback = (row) => {
          // this.codeTableName = this.$t('btn.mapBuilder.selectCodeTable');
          Store.dispatch('common/viewFileData', row.FILE_ID).then(() => {
            if (filetype == 'inputMap') {
              this.$refs.input_data.value = null;
              if (typeof this.fileContent === 'object') {
                this.inputFileContent = JSON.stringify(this.fileContent, null, '\t');
              } else {
                this.inputFileContent = this.fileContent.toString();
              }
              this.fileID = row.FILE_ID;
              this.inputFileName = row.USR_FILE_NAME;
              this.inputFileNameSave = row.USR_FILE_NAME;
              this.inputFileSize = row.USR_FILE_SIZE;
              this.inputFileExtension = row.USR_FILE_TYPE;
              this.inputFolderId = row.FOLD_ID;
              this.lastFoldIdBiz = row.FOLD_ID;
            } else if (filetype == 'mapper') {
              this.$refs.mapper_data.value = null;
              if (typeof this.fileContent === 'object') {
                this.mapperFileContent = JSON.stringify(this.fileContent, null, '\t');
              } else {
                this.mapperFileContent = this.fileContent.toString();
              }
              this.mapperFileID = row.FILE_ID;
              this.mapperFileName = row.USR_FILE_NAME;
              this.mapperFileNameSave = row.USR_FILE_NAME;
              this.mapperFileSize = row.USR_FILE_SIZE;
              this.mapperFileExtension = row.USR_FILE_TYPE;
              this.mapperFolderId = row.FOLD_ID;
              this.resultField = '';
              this.buildResultMSG = '';
              this.isSaved = true;
              this.isDisableChkMap = true;
              this.lastFoldIdMapper = row.FOLD_ID;
              this.checkInYN = '';
            }
          });
        };
        // this.$emit('openLoadFile', {mode : 'Load',filetype:filetype,lastFoldId: this.lastFoldId, callback});
        this.$emit('openLoadFile', {
          mode: 'Load',
          filetype: filetype,
          lastFoldIdBiz: this.lastFoldIdBiz,
          lastFoldIdMapper: this.lastFoldIdMapper,
          callback,
        });
      }
      if (mode == 'Save') {
        let callback = (row) => {
          if (filetype == 'inputMap') {
            this.inputFileName = row.USR_FILE_NAME;
            this.inputFileNameSave = row.USR_FILE_NAME;
            this.$refs.input_data.value = null;
            this.inputFileContent = row.file;
            this.fileID = row.FILE_ID;
            this.inputFileSize = row.USR_FILE_SIZE;
            this.inputFileExtension = row.USR_FILE_TYPE;
            this.inputFolderId = row.FOLD_ID;
            this.lastFoldIdBiz = row.FOLD_ID;
          } else if (filetype == 'mapper') {
            this.$refs.mapper_data.value = null;
            this.mapperFileContent = row.file;
            this.mapperFileID = row.FILE_ID;
            this.mapperFileName = row.USR_FILE_NAME;
            this.mapperFileNameSave = row.USR_FILE_NAME;
            this.mapperFileSize = row.USR_FILE_SIZE;
            this.mapperFileExtension = row.USR_FILE_TYPE;
            this.mapperFolderId = row.FOLD_ID;
            this.lastFoldIdMapper = row.FOLD_ID;
            this.isSaved = true;
          } else if (filetype == 'output') {
            this.outputFileName = row.USR_FILE_NAME;
            this.outputFileNameSave = row.USR_FILE_NAME;
            this.outputFileContent = row.file;
            this.outputFileID = row.FILE_ID;
            this.outputFileSize = row.USR_FILE_SIZE;
            this.outputFileExtension = row.USR_FILE_TYPE;
            this.outputFolderId = row.FOLD_ID;
          }
        };
        let content = [];
        if (filetype == 'inputMap') {
          content.push(this.inputFileContent);
          if (this.inputFileExtension == '') {
            this.inputFileExtension = 'txt';
          }
          content.push(this.inputFileExtension);
          content.push(this.inputFileNameSave);
          content.push('BIZ');
        } else if (filetype == 'mapper') {
          content.push(this.mapperFileContent);
          if (this.mapperFileExtension == '') {
            this.mapperFileExtension = 'cpp';
          }
          content.push(this.mapperFileExtension);
          content.push(this.mapperFileNameSave);
          content.push('MAP');
        } else if (filetype == 'output') {
          content.push(this.outputFileContent);
          if (this.outputFileExtension == '') {
            this.outputFileExtension = 'txt';
          }
          content.push(this.outputFileExtension);
          content.push(this.outputFileNameSave);
          content.push('OUT');
        }
        // this.$emit('openLoadFile', {mode : 'Save',filetype:filetype, content, callback});
        this.$emit('openLoadFile', {
          mode: 'Save',
          filetype: filetype,
          content,
          lastFoldIdBiz: this.lastFoldIdBiz,
          lastFoldIdMapper: this.lastFoldIdMapper,
          callback,
        });
      }
    },
    openMapperListDialog(selectItem) {
      this.$emit('openMapperListDialog');
    },
    // 203705 mapbuilder fix issues 21
    clearView(type) {
      if (type == 'output') {
        this.outputFileName = '';
        this.outputFileContent = '';
        this.outputFileNameSave = '';
        this.outputFileID = '';
        this.outputFileContent = '';
      } else if (type === 'mapper') {
        this.mapperFileName = '';
        this.mapperFileContent = '';
        this.version = '';
        this.mapperFileID = '';
        this.isDisableChkMap = true;
        this.checkInYN = '';
        this.resultField = '';
        this.buildResultMSG = '';
        this.mapperFileNameSave = '';
        this.mapperFileSize = '';
        this.mapperFileExtension = '';
        this.mapperFolderId = '';
        const query = this.$route.query;
        if (query.tab == 'Mapper') {
          this.$router.push({
            query: {
              tab: 'Mapper',
            },
          });
        }
      } else if (type === 'biz') {
        this.inputFileName = '';
        this.inputFileContent = '';
        this.fileID = '';
        this.isDisableChkMap = true;
        this.inputFolderId = '';
        this.inputFileNameSave = '';
      }
    },
    expandView(type) {
      if (type == 'biz') {
        this.$refs.bizFile.cminstance.setOption('fullScreen', true);
        //Create label, button close expand view
        var div = document.createElement('div');
        div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
          title: 'BizData File',
          iconClass: ' icon-collapse-m-biz',
        });
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'm-biz-add-row' });
        $('.zoom-m-biz-data .CodeMirror-fullscreen').prepend(div);
        $('.icon-collapse-m-biz').on('click', { type: 'm-biz' }, this.closeExpand);
      } else if (type === 'mapper') {
        this.$refs.mapperFile.cminstance.setOption('fullScreen', true);
        //Close another view
        this.$refs.bizFile.cminstance.setOption('fullScreen', false);
        $('.m-biz-add-row').remove();
        $('.output-add-row').remove();
        this.$refs.outputFile.cminstance.setOption('fullScreen', false);
        //Create label, button close expand view
        var div = document.createElement('div');
        div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
          title: 'Mapper File',
          iconClass: 'icon-collapse-mapper',
        });
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'mapper-add-row' });
        $('.zoom-mapper-file .CodeMirror-fullscreen').prepend(div);
        $('.icon-collapse-mapper').on('click', { type: 'mapper' }, this.closeExpand);
      } else if (type === 'output') {
        this.$refs.outputFile.cminstance.setOption('fullScreen', true);
        //Create label, button close expand view
        var div = document.createElement('div');
        div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
          title: 'Output File',
          iconClass: 'icon-collapse-output',
        });
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'output-add-row' });
        $('.zoom-output-file .CodeMirror-fullscreen').prepend(div);
        $('.icon-collapse-output').on('click', { type: 'output' }, this.closeExpand);
      } else if (type === 'resultBuild') {
        this.$refs.resultBuild.cminstance.setOption('fullScreen', true);
        //Close another view
        this.$refs.bizFile.cminstance.setOption('fullScreen', false);
        $('.m-biz-add-row').remove();
        $('.output-add-row').remove();
        this.$refs.outputFile.cminstance.setOption('fullScreen', false);
        //Create label, button close expand view
        var div = document.createElement('div');
        div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
          title: 'Result of compile or execution',
          iconClass: 'icon-build-result',
        });
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'build-add-row' });
        $('.zoom-mapper-file .CodeMirror-fullscreen').prepend(div);
        $('.icon-build-result').on('click', { type: 'build' }, this.closeExpand);
      }
    },
    closeExpand(e) {
      if (e.data.type == 'm-biz') {
        $('.m-biz-add-row').remove();
        this.$refs.bizFile.cminstance.setOption('fullScreen', false);
      } else if (e.data.type == 'mapper' || e.data.type == 'build') {
        $('.mapper-add-row').remove();
        $('.build-add-row').remove();
        this.$refs.mapperFile.cminstance.setOption('fullScreen', false);
        this.$refs.resultBuild.cminstance.setOption('fullScreen', false);
      } else if (e.data.type == 'output') {
        $('.output-add-row').remove();
        this.$refs.outputFile.cminstance.setOption('fullScreen', false);
      }
    },
    updateMapper(data) {
      this.$refs.mapper_data.value = null;
      this.mapperFileContent = data.fileContent;
      this.mapperFileName = data.MAPPER_NAME;
      this.mapperFileNameSave = data.MAPPER_NAME;
      this.mapperFileID = '';
      this.mapperFileSize = data.MAPPER_SIZE;
      this.resultField = '';
      this.buildResultMSG = '';
      this.isSaved = false;
      this.isDisableChkMap = true;
      this.version = data.MAPP_VER;
      if (data.CODE_CTG_NAME == null) {
        this.codeTableName = this.$t('btn.mapBuilder.selectCodeTable');
      } else {
        this.codeTableName = data.CODE_CTG_NAME;
      }
    },
    openMapperCheckInDialog() {
      if (this.accessCheckIn == false) {
        this.validateMessage = this.$t('msg.mapBuilder.noSuccessExecute');
        this.$refs.validateDialog.dialog = true;
        return;
      }
      let dataCheckIn = [];
      dataCheckIn.push(this.mapperFileID);
      dataCheckIn.push(this.mapperFileContent);
      dataCheckIn.push(this.mapperFileSize);
      dataCheckIn.push(this.libraryVersion);
      this.$emit('openMapperLayoutCheckIn', dataCheckIn);
    },
    openCodeTableDialog() {
      this.$emit('openCodeTableDialog');
    },
    updateSelectCode(data) {
      this.codeTableName = data.CODE_CTG_NAME;
      this.selectCodeId = data.CODE_CTG_ID;
    },
    onChangeTextView(type) {
      if (type === 'biz') {
        this.$refs.input_data.value = null;
      } else if (type === 'mapper') {
        this.$refs.mapper_data.value = null;
      }
    },
    // 2022.01.13 213960 SPKA-365 Group 2 buttons to v-menu
    changeLoadType(type) {
      if (type.value === 'local') {
        this.loadMapperLocal();
      } else {
        this.openLoadFilePop({ mode: 'Load', filetype: 'mapper' });
      }
    },
    changeLoadInputType(type) {
      if (type.value === 'local') {
        this.loadInputLocal();
      } else {
        this.openLoadFilePop({ mode: 'Load', filetype: 'inputMap' });
      }
    },
    openCheckOut() {
      this.$refs.checkOutDialog.dialog = true;
    },

    onClickOkay() {
      let lockItems = {
        header: ['MAP_KIND', 'MAP_PRCS_NO', 'LOCK_YN'],
        data: [
          {
            MAP_KIND: '',
            MAP_PRCS_NO: '',
            LOCK_YN: '',
          },
        ],
      };
      lockItems.data[0].MAP_KIND = 'MAPP';
      lockItems.data[0].MAP_PRCS_NO = this.currenVersionData.MAP_PRCS_NO;
      lockItems.data[0].LOCK_YN = 'Y';
      console.log(lockItems);
      Store.dispatch('map/updateLock', lockItems).then(() => {
        this.checkInYN = 'Y';
        console.log('--------- Finished to process CHECKOUT ----------');
      });
    },
    updateMapperStatus(status) {
      this.checkInYN = status;
    },
  },
};
</script>

<style>
.select-code-table {
  text-decoration: underline;
  font-size: 12px;
  height: 16px;
  font-weight: bold;
  display: inline-block;
  margin-right: 5px;
  max-width: 222px;
  width: 221px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mapper-file-name {
  display: inline-block;
  height: 26px;
  line-height: 20px;
  background: none;
  border: 1px solid #7d838d;
  border-bottom: none;
  align-items: center;
  letter-spacing: 0.5px;
  font-weight: bold;
  font-size: 12px;
  padding: 0 5px;
  left: 0;
  white-space: nowrap;
  max-width: calc(100% - 285px);
  overflow: hidden;
  text-overflow: ellipsis;
}

.mapper-file-name.map-version {
  border: inherit;
}

.theme--dark .mapper-file-name {
  color: #f99dd4;
}
.theme--light .mapper-file-name {
  color: #ba0070;
}

.theme--dark .map-version {
  color: #f99dd4;
}
.theme--light .map-version {
  color: #ba0070;
}
.mapper-status {
  border-radius: 8px;
  height: 22px;
  margin-top: 2px;
  width: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  letter-spacing: 0.5px;
  font-weight: bold;
}
.theme--dark .mapper-status {
  color: #00210b;
}
.theme--dark .mapper-status.status-checked-in {
  background: #faa287;
}
.theme--dark .mapper-status.status-checked-out {
  background: #87ccfa;
}
.theme--light .mapper-status {
  color: #00210b;
}
.theme--light .mapper-status.status-checked-in {
  background: #f9e2db;
}
.theme--light .mapper-status.status-checked-out {
  background: #dbedf9;
}
</style>
